/**
 * Контроллер страницы блога.
 */
export class BlogController {
  private container: HTMLElement
  private resetBtn: HTMLElement | null

  /**
   * Создаёт экземпляр контроллера блога.
   *
   * @param {HTMLElement} container - Корневой HTML-элемент блога
   */
  constructor(container: HTMLElement) {
    this.container = container

    this.init()
  }

  /**
   * Инициализирует контроллер и подключает обработчики событий.
   */
  private init() {
    const filterTabsEl = this.container.querySelector<HTMLElement>(
      '[data-blog="filters"]'
    )

    this.resetBtn = this.container.querySelector<HTMLElement>(
      '[data-blog="reset"]'
    )

    filterTabsEl?.addEventListener('click', this.onFilterTabClick)
    this.resetBtn?.addEventListener('click', this.onResetButtonClick)
  }

  /**
   * Обрабатывает клик по вкладке фильтра.
   *
   * @param {Event} event - Событие клика
   */
  private onFilterTabClick = (event: Event) => {
    const target = event.target as HTMLElement
    const tabEl = target.closest<HTMLElement>('[data-blog-filter]')
    if (!tabEl) return

    const filterValue = tabEl.getAttribute('data-blog-filter')
    if (!filterValue) return

    const isActive = tabEl.classList.contains('is-active')

    this.resetFilters()

    if (!isActive) {
      this.applyFilter(filterValue)
    }

    this.updateActiveTab(tabEl, isActive)
  }

  /**
   * Обрабатывает клик по кнопке сброса фильтров.
   */
  private onResetButtonClick = () => {
    this.resetFilters()
    this.updateActiveTab(null, false)
  }

  /**
   * Применяет фильтр к списку постов.
   *
   * @param {string} filterValue - Значение фильтра
   */
  private applyFilter(filterValue: string) {
    const postElements =
      this.container.querySelectorAll<HTMLElement>('[data-blog-card]')
    postElements.forEach((postEl) => {
      const postCategory = postEl.getAttribute('data-category')
      if (postCategory !== filterValue) {
        postEl.classList.add('is-hidden')
      }
    })

    this.resetBtn?.classList.add('is-shown')
  }

  /**
   * Сбрасывает фильтры
   */
  private resetFilters() {
    const postElements =
      this.container.querySelectorAll<HTMLElement>('[data-blog-card]')
    postElements.forEach((postEl) => {
      postEl.classList.remove('is-hidden')
    })

    this.resetBtn?.classList.remove('is-shown')
  }

  /**
   * Обновляет активное состояние вкладки фильтра.
   *
   * @param {HTMLElement} tabEl - HTML-элемент вкладки
   * @param {boolean} isActive - Текущее состояние активности вкладки
   */
  private updateActiveTab(tabEl: HTMLElement | null, isActive: boolean) {
    const activeTabs = this.container.querySelectorAll<HTMLElement>(
      '[data-blog-filter].is-active'
    )
    activeTabs.forEach((el) => el.classList.remove('is-active'))

    if (!isActive && tabEl) {
      tabEl.classList.add('is-active')
    }
  }
}
